import React from 'react';
import CarouselBase from './CarouselBase';

export const RenderInstructional = ({ section, show, callback }) => (show ? <CarouselBase callback={callback} section={section} /> : null);
